__turbopack_context__.v({
  "mbl": "spaces-module-scss-module__pZRcVW__mbl",
  "mbm": "spaces-module-scss-module__pZRcVW__mbm",
  "mbn": "spaces-module-scss-module__pZRcVW__mbn",
  "mbs": "spaces-module-scss-module__pZRcVW__mbs",
  "mbx": "spaces-module-scss-module__pZRcVW__mbx",
  "mbxl": "spaces-module-scss-module__pZRcVW__mbxl",
  "mbxxl": "spaces-module-scss-module__pZRcVW__mbxxl",
  "ml": "spaces-module-scss-module__pZRcVW__ml",
  "mll": "spaces-module-scss-module__pZRcVW__mll",
  "mlm": "spaces-module-scss-module__pZRcVW__mlm",
  "mln": "spaces-module-scss-module__pZRcVW__mln",
  "mls": "spaces-module-scss-module__pZRcVW__mls",
  "mlx": "spaces-module-scss-module__pZRcVW__mlx",
  "mlxl": "spaces-module-scss-module__pZRcVW__mlxl",
  "mlxxl": "spaces-module-scss-module__pZRcVW__mlxxl",
  "mm": "spaces-module-scss-module__pZRcVW__mm",
  "mn": "spaces-module-scss-module__pZRcVW__mn",
  "mrl": "spaces-module-scss-module__pZRcVW__mrl",
  "mrm": "spaces-module-scss-module__pZRcVW__mrm",
  "mrn": "spaces-module-scss-module__pZRcVW__mrn",
  "mrs": "spaces-module-scss-module__pZRcVW__mrs",
  "mrx": "spaces-module-scss-module__pZRcVW__mrx",
  "mrxl": "spaces-module-scss-module__pZRcVW__mrxl",
  "mrxxl": "spaces-module-scss-module__pZRcVW__mrxxl",
  "ms": "spaces-module-scss-module__pZRcVW__ms",
  "mtl": "spaces-module-scss-module__pZRcVW__mtl",
  "mtm": "spaces-module-scss-module__pZRcVW__mtm",
  "mtn": "spaces-module-scss-module__pZRcVW__mtn",
  "mts": "spaces-module-scss-module__pZRcVW__mts",
  "mtx": "spaces-module-scss-module__pZRcVW__mtx",
  "mtxl": "spaces-module-scss-module__pZRcVW__mtxl",
  "mtxxl": "spaces-module-scss-module__pZRcVW__mtxxl",
  "mx": "spaces-module-scss-module__pZRcVW__mx",
  "mxl": "spaces-module-scss-module__pZRcVW__mxl",
  "mxxl": "spaces-module-scss-module__pZRcVW__mxxl",
  "pbl": "spaces-module-scss-module__pZRcVW__pbl",
  "pbm": "spaces-module-scss-module__pZRcVW__pbm",
  "pbn": "spaces-module-scss-module__pZRcVW__pbn",
  "pbs": "spaces-module-scss-module__pZRcVW__pbs",
  "pbx": "spaces-module-scss-module__pZRcVW__pbx",
  "pbxl": "spaces-module-scss-module__pZRcVW__pbxl",
  "pbxxl": "spaces-module-scss-module__pZRcVW__pbxxl",
  "pl": "spaces-module-scss-module__pZRcVW__pl",
  "pll": "spaces-module-scss-module__pZRcVW__pll",
  "plm": "spaces-module-scss-module__pZRcVW__plm",
  "pln": "spaces-module-scss-module__pZRcVW__pln",
  "pls": "spaces-module-scss-module__pZRcVW__pls",
  "plx": "spaces-module-scss-module__pZRcVW__plx",
  "plxl": "spaces-module-scss-module__pZRcVW__plxl",
  "plxxl": "spaces-module-scss-module__pZRcVW__plxxl",
  "pm": "spaces-module-scss-module__pZRcVW__pm",
  "pn": "spaces-module-scss-module__pZRcVW__pn",
  "prl": "spaces-module-scss-module__pZRcVW__prl",
  "prm": "spaces-module-scss-module__pZRcVW__prm",
  "prn": "spaces-module-scss-module__pZRcVW__prn",
  "prs": "spaces-module-scss-module__pZRcVW__prs",
  "prx": "spaces-module-scss-module__pZRcVW__prx",
  "prxl": "spaces-module-scss-module__pZRcVW__prxl",
  "prxxl": "spaces-module-scss-module__pZRcVW__prxxl",
  "ps": "spaces-module-scss-module__pZRcVW__ps",
  "ptl": "spaces-module-scss-module__pZRcVW__ptl",
  "ptm": "spaces-module-scss-module__pZRcVW__ptm",
  "ptn": "spaces-module-scss-module__pZRcVW__ptn",
  "pts": "spaces-module-scss-module__pZRcVW__pts",
  "ptx": "spaces-module-scss-module__pZRcVW__ptx",
  "ptxl": "spaces-module-scss-module__pZRcVW__ptxl",
  "ptxxl": "spaces-module-scss-module__pZRcVW__ptxxl",
  "px": "spaces-module-scss-module__pZRcVW__px",
  "pxl": "spaces-module-scss-module__pZRcVW__pxl",
  "pxxl": "spaces-module-scss-module__pZRcVW__pxxl",
});
